import React, { useState, useEffect } from 'react';
// import './editprofile.css'; 
import nakamu from './images/nakamu.png';
import './adduser.css';
// import './OneToOneAdd.css';

const EditProfile = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    occupation: '',
    email: '',
    number: '',
    company: '',
    date: '',
    collageName: '',
    year: '',
    universityName: 'ahmedabaduniversity',
    hlabc: 'Member',
  });

  const [profileImage, setProfileImage] = useState(nakamu); // Default profile image
  const [successMessage, setSuccessMessage] = useState(''); // For success feedback

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('token');

      if (!token) {
        alert('No authentication token found. Please log in again.');
        return;
      }

      try {
        const apiUrl = process.env.REACT_APP_SERVER_IP + '/api/admin/my-profile';
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();

          // Convert fetched date to 'YYYY-MM-DD' format for input field
          const formattedDate = data.date ? new Date(data.date).toISOString().split('T')[0] : '';

          setFormData({
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            occupation: data.occupation || '',
            email: data.email || '',
            number: data.number || '',
            company: data.company || '',
            date: formattedDate, // Ensure proper formatting
            collageName: data.collageName || '',
            year: data.year || '',
            profilePhoto: null,
            universityName: data.universityName || 'Ahmedabad University', // Default to 'ahmedabaduniversity'
            hlabc: data.hlabc || 'Member',
          });

          if (data.profilePhoto) {
            setProfileImage(data.profilePhoto);
          }
        } else {
          alert('Failed to fetch profile data.');
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
        alert('Error fetching profile data.');
      }
    };

    fetchProfile();
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        profilePhoto: file, // Store file object
      }));
      setProfileImage(URL.createObjectURL(file)); // Show selected image preview
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const apiUrl = process.env.REACT_APP_SERVER_IP + '/api/admin/my-profile';

    // Prepare form data
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key]) formDataToSend.append(key, formData[key]);
    });

    if (formData.profilePhoto) {
      formDataToSend.append('profilePhoto', formData.profilePhoto);
    }

    var object = {};
    formDataToSend.forEach(function (value, key) {
      object[key] = value;
    });

    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(object),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage('Details Updated Successfully.');
        alert('Details Updated Successfully.');
        setTimeout(() => setSuccessMessage(''), 3000);
      } else {
        console.error('❌ Server Error:', data);
        alert('Error updating profile: ' + (data.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('❌ Network Error:', error);
      alert('An error occurred while updating your profile.');
    }
  };

  return (
    <div className="contain">
      <main className="main-content">
        <div className="form-containerCommon">
          {/* <div className="profile-photo-section">
            <img src={profileImage} alt="Profile" className="profile-photo" />
            <input type="file" id="profilePhoto" name="profilePhoto" accept="image/*" onChange={handleFileChange} className="upload-photo-input" />
            <div>
            <button className="upload-photo-btn">Upload New Profile</button>
            </div>
          </div> */}
          <form onSubmit={handleSubmit}>
            <h2 className='name'>Edit Profile</h2>
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input type="text" id="lastName" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required />
              </div>
            </div>
            <div className="form-group">
              <input
                type="text"
                id="occupation"
                name="occupation"
                placeholder="Occupation"
                value={formData.occupation}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input type="email" id="email" name="email" placeholder="E-mail" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="number"
                placeholder="Contact Number"
                value={formData.number}
                onChange={handleChange}
                maxLength="10"
                pattern="\d{10}"
                title="Please enter exactly 10 digits"
                required
              />
            </div>
            <div className="form-group">
              <input type="text" id="company" name="company" placeholder="Company Name" value={formData.company} onChange={handleChange} required />
            </div>

            <div className="form-group">
              <input
                type="date"
                id="date"
                name="date"
                placeholder="Date"
                value={formData.date}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]} // Prevent future dates
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                id="collageName"
                name="collageName"
                placeholder="Collage Name"
                value={formData.collageName}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                id="year"
                name="year"
                placeholder="Passing Year"
                value={formData.year}
                onChange={handleChange}
                maxLength="4" // Ensures no more than 4 characters
                pattern="^\d{4}$" // Ensures only exactly 4 digits
                title="Please enter a 4-digit year" // Title for validation
              />
            </div>



            <div className="radio-sectionn">
              <label className="section-labell">HLABC :- </label>
              <div className="radio-optionss">
                <label>
                  <input type="radio" name="hlabc" value="Member" checked={formData.hlabc === 'Member'} onChange={handleChange} />
                  Member
                </label>
                <label>
                  <input type="radio" name="hlabc" value="spouse" checked={formData.hlabc === 'spouse'} onChange={handleChange} />
                  Spouse
                </label>
              </div>
            </div>

            <div className="radio-sectionn">
              <label className="section-labell">University Name :-</label>
              <div className="radio-optionss">
                <label>
                  <input
                    type="radio"
                    name="universityName"
                    value="Gujarat University"
                    checked={formData.universityName === 'Gujarat University'}
                    onChange={handleChange}
                  />
                  Gujarat University
                </label>
                <label>
                  <input
                    type="radio"
                    name="universityName"
                    value="Ahmedabad University"
                    checked={formData.universityName === 'Ahmedabad University'}
                    onChange={handleChange}
                  />
                  Ahmedabad University
                </label>
              </div>
            </div>



            <button type="submit" className="btnOne">
              Update Details
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default EditProfile;
